import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VAppBar,
        {
          attrs: {
            id: "toolbar",
            app: "",
            color: `primary ${_vm.$vuetify.theme.dark ? "darken-1" : ""}`,
            dark: "",
          },
        },
        [
          _c(VAppBarNavIcon, {
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              },
            },
          }),
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(VImg, {
                staticClass: "shrink mr-2",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  alt: "Logo Gestão por Competências",
                  contain: "",
                  src: "/static/images/desenvolva/desenvolva3.png",
                  transition: "scale-transition",
                  width: "140",
                },
                on: {
                  click: function ($event) {
                    return _vm.$router.push("/inicio")
                  },
                },
              }),
            ],
            1
          ),
          _c(VSpacer),
          _c(
            "p",
            {
              staticClass:
                "font-weight-light body-2 hidden-sm-and-down pt-4 px-2",
            },
            [
              _vm._v(" " + _vm._s(_vm.usuario.nome)),
              _c("br"),
              _c(
                "span",
                {
                  staticClass:
                    "font-weight-light caption secondary--text text--lighten-2",
                },
                [_vm._v(" Sua sessão expira às " + _vm._s(_vm.fimSessao) + " ")]
              ),
            ]
          ),
          _c(
            VMenu,
            {
              attrs: {
                "nudge-bottom": 10,
                "offset-y": "",
                origin: "center center",
                transition: "scale-transition",
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            staticClass: "hidden-xs-only",
                            attrs: { icon: "", large: "", text: "" },
                          },
                          on
                        ),
                        [
                          _c(
                            VAvatar,
                            { attrs: { size: "30px" } },
                            [_c(VIcon, [_vm._v("account_circle")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                VList,
                [
                  _c(
                    VListItem,
                    {
                      on: {
                        click: function ($event) {
                          return _vm.to("/perfil/cadastrar")
                        },
                      },
                    },
                    [
                      _c(
                        VListItemIcon,
                        [_c(VIcon, [_vm._v("person")])],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [_c(VListItemTitle, [_vm._v("Meu Perfil")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VListItem,
                    {
                      on: {
                        click: function ($event) {
                          return _vm.to("/logout")
                        },
                      },
                    },
                    [
                      _c(
                        VListItemIcon,
                        [
                          _c(VIcon, { attrs: { color: "error" } }, [
                            _vm._v(" power_settings_new "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            { staticClass: "error--text" },
                            [_vm._v(" Sair ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VNavigationDrawer,
        {
          staticClass: "sigec-drawer",
          attrs: { fixed: "", temporary: "" },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column fill-height" },
            [
              _c(
                VList,
                [
                  _c(
                    VListItem,
                    [
                      _c(
                        VListItemAvatar,
                        [
                          _c(VIcon, { attrs: { size: "50px" } }, [
                            _vm._v(" account_circle "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            {
                              staticClass:
                                "body-1 primary--text nome-menu-lateral",
                            },
                            [_vm._v(" " + _vm._s(_vm.usuario.nome) + " ")]
                          ),
                          _c(VListItemSubtitle, [
                            _c("span", { staticClass: "caption" }, [
                              _vm._v(
                                "Sua sessão expira às " + _vm._s(_vm.fimSessao)
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VDivider),
              _c(
                VList,
                {
                  staticClass: "d-flex flex-column",
                  attrs: { dense: "", height: "100%", nav: "" },
                },
                [
                  _vm._l(_vm.menuItens, function (item) {
                    return _c(
                      VListItem,
                      {
                        key: item.link,
                        staticClass: "sigec-list-item primary--text",
                        attrs: { to: item.link },
                      },
                      [
                        _c(
                          VListItemIcon,
                          [_c(VIcon, [_vm._v(_vm._s(item.icon))])],
                          1
                        ),
                        _c(VListItemTitle, [_vm._v(_vm._s(item.nome))]),
                      ],
                      1
                    )
                  }),
                  _c(
                    VListItem,
                    {
                      staticClass: "mt-auto sigec-list-item",
                      on: { click: _vm.toogleModoEscuro },
                    },
                    [
                      _c(
                        VListItemIcon,
                        [_c(VIcon, [_vm._v(" contrast ")])],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            {
                              class: _vm.$vuetify.theme.dark
                                ? ""
                                : "grey--text text--darken-2",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.theme.dark
                                      ? "Modo Claro"
                                      : "Modo Escuro"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VListItem,
                    {
                      staticClass: "sigec-list-item",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.drawer = !_vm.drawer
                        },
                      },
                    },
                    [
                      _c(
                        VListItemIcon,
                        [
                          _c(VIcon, { attrs: { color: "warning" } }, [
                            _vm._v(" keyboard_double_arrow_left "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            { staticClass: "warning--text" },
                            [_vm._v(" Ocultar Menu ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VListItem,
                    {
                      staticClass: "mb-2 sigec-list-item",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.to("/logout")
                        },
                      },
                    },
                    [
                      _c(
                        VListItemIcon,
                        [
                          _c(VIcon, { attrs: { color: "error" } }, [
                            _vm._v(" power_settings_new "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            { staticClass: "error--text" },
                            [_vm._v(" Sair ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }